import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InfoDialogData } from '../../dialog-models';
import { SharedModule } from '../../../../modules/shared.module';
import { CommonModule } from '@angular/common';
import { ApplicationService } from '../../../application.service';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.css']
})
export class InfoDialogComponent implements OnInit {
  cancelButton: string = 'cancel';
  acceptButton: string = 'close';
  constructor(public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoDialogData) { }

  ngOnInit() {
    if (this.data.cancel && typeof this.data.cancel == 'string') {
      this.cancelButton = this.data.cancel;
    }
    if (this.data.accept && typeof this.data.accept == 'string') {
      this.acceptButton = this.data.accept;
    }
  }

  accept() {
    if (this.data.accept) {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close();
    }
  }

  cancel() {
    this.dialogRef.close();
  }

}
